const DAWA_REGIONS = 'regions';
const DAWA_MUNICIPALITIES = 'municipalities';
const DAWA_ADDRESSES = 'addresses';

class ReactSelectFormatter {

    static format(array) {
        return array.map(item => {
            return {value: item.id, label: item.name}
        });
    }

    static formatCourseCategories(array) {
        return array.map(item => {
            return {
                id: item.id,
                name: item.title,
                isSpecial: item.is_special,
                parentId: item.parent_id === 0 ? null: item.parent_id,
                children: item.children
            };
        })
    }

    static formatCompanyTasks(array) {
        return array.map( item => {
            return {
                id: item.id,
                name: item.title,
                parentId: item.parentId,
                children: item.children
            };
        });
    }

    static formatDAWA(array, type) {
        return array.map(item => {
            if (type === DAWA_REGIONS) {
                return {value: item.kode, label: item.navn};
            }
            if (type === DAWA_MUNICIPALITIES) {
                return {value: item.kode, label: item.navn, regionId: item.regionskode};
            }
            if (type === DAWA_ADDRESSES) {
                return {value: item.adresse.id, label: item.tekst};
            }
        })
    }

    static formatKeywordsPacks(array) {
        return array.map(item => {
            return {value: item.keywordsCount, label: item.keywordsCount}
        });
    }

    static getIds(array) {
        return array.map(item => {
            return item.value;
        });
    }
}

export default ReactSelectFormatter;


// WEBPACK FOOTER //
// ./web/src/services/ReactSelectFormatter.js